import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as LoginActions from "../../store/loginService/actions";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { getPayAsYouGoPackageDetails, getCancelledUserFamily } from "../../store/service";
import { IProtectionPlanResponse, IPackage, IProduct, RECEIVE_PROTECTION_PLAN } from "../../store/protectionPlanService/ezs/types";
import { useTranslation } from "react-i18next";
interface IProps {
    closeDialog: any;
    dialogId: string;
    onButtonClick: any;
    history: any;
}

interface ServiceListDetails {
    noOfServicesToShow: number;
    isServiceListExpanded: boolean;
}

const CancellationContinuationDialog: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const changedServices = useSelector((state: ApplicationState) => {
        return state.checkContractChangeState.cancellatinoContinuationData;
    });
    const requestLogout = () => dispatch(LoginActions.actionCreators.logout(props.history));
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const [isPayAsYouGo, setIsPayAsYouGo] = useState(false);
    const [payAsYouGoPkgDetails, setPayAsYouGoPkgDetails] = useState({});
    const [householdMembers, setHouseholdMembers] = useState([] as any);
    const [isLoading, setisLoading] = useState(false);
    const [serviceListDetails, setServiceListDetails] = useState<ServiceListDetails>({ noOfServicesToShow: 5, isServiceListExpanded: false });
    const { t: tLang, i18n: i18nLang } = useTranslation();

    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });
    useEffect(() => {
        setisLoading(true);
        getPayAsYouGoPackageDetails()
            .then((data: any) => {
                setIsPayAsYouGo(data.isUserPaidFamilyMembers);
                setPayAsYouGoPkgDetails(data);
                setIsPayAsYouGo(data.isUserPaidFamilyMembers);
                getCancelledFamilyMember(data.packageId);
            })
            .catch(() => {
                setisLoading(false);
            });
    }, []);

    const getCancelledFamilyMember = (packageId: any) => {
        const requestBody = {
            packageId: packageId,
        };
        setisLoading(true);
        getCancelledUserFamily(requestBody)
            .then((data) => {
                if (!data["hasError"] && data["familyMembers"]) {
                    const householdMembers = data["familyMembers"].filter((x: any) => x.accountType === "Family Plan Adult")
                        ? data["familyMembers"].filter((x: any) => x.accountType === "Family Plan Adult")
                        : [];
                    setHouseholdMembers(householdMembers);
                }
                setisLoading(false);
            })
            .catch(() => {
                setisLoading(false);
            });
    };

    const onSubmit = () => {
        if (changedServices != null) {
            redirectToProtectionPlanBilling(changedServices);
        }
    };
    const getPackageOrOfferPrice = (obj: any) => {
        if (obj.OfferPrice != null && obj.IsOffercodeApplied && Number(obj.OfferPrice) != 0) {
            return Number(obj.OfferPrice);
        } else {
            return Number(obj.PackagePrice);
        }
    };

    const redirectToProtectionPlanBilling = (obj: any) => {
        let protectionPlanData: IProtectionPlanResponse;
        var packages: IPackage[] = [];
        let products: IProduct[] = [];

        for (let i = 0; i < obj.ServiceList.length; i++) {
            let prd: IProduct = {
                id: obj.ServiceList[i].Id,
                rowId: i,
                displayName: obj.ServiceList[i].DisplayName,
                name: obj.ServiceList[i].Name, 
                labelText: "",
            };
            products.push(prd);
        }
        var tempPackage: IPackage = {
            BasePackagePrice: 0,
            BillingText: "",
            HasUserCancelled: false,
            IsActive: true,
            IsPacakgeUpgradable: true,
            IsPackageCancel: false,
            PackagId: Number(obj.PackageId),
            PackageCode: obj.PackageCode,
            PackageForCacellationContinuation: true,
            PackageName: obj.PackageName,
            PackagePrice: getPackageOrOfferPrice(obj),
            PackagePriceYearly: 0.0, //Number(obj.PackagePriceYearly),
            SubcriptionType: obj.SubcriptionType == null ? "MONTHLY" : obj.SubcriptionType,
            ActionButtonText: "Renew",
            DisplayPaymentInfo: true,
            Products: products,
            RemainingTrialDays: 0,
        };
        packages.push(tempPackage);

        protectionPlanData = {
            packageList: packages,
            productList: [],
        };
        dispatch({ type: RECEIVE_PROTECTION_PLAN, protectionPlanData: protectionPlanData });
        props.onButtonClick(isPayAsYouGo && householdMembers.length > 0, payAsYouGoPkgDetails);
        props.closeDialog();
    };

    const onLogout = () => {
        requestLogout();
        dispatch(ConfigurationActions.actionCreators.getRedirectTokenAction(""));
    };

    const showLessOrMoreServices = (e: any): void => {
        e.preventDefault();
        let serviceList = changedServices?.ServiceList;
        if (!serviceListDetails.isServiceListExpanded) {
            setServiceListDetails({ noOfServicesToShow: serviceList.length, isServiceListExpanded: true });
        } else {
            setServiceListDetails({ noOfServicesToShow: 5, isServiceListExpanded: false });
        }
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <h1>
                    {tLang("dashboard.cacellationContinuationDialog.renewPlanOrService")}{" "}
                    {isPayAsYouGo ? tLang("dashboard.cacellationContinuationDialog.plan") : tLang("dashboard.cacellationContinuationDialog.service")}
                </h1>
            </div>

            <div className={`dialog-body ${isLoading ? "loading" : ""}`}>
                {changedServices != null ? (
                    <React.Fragment>
                        <p>{changedServices.GlobalOffercodeText}</p>
                        <h4>{tLang("dashboard.cacellationContinuationDialog.renewEssentialPackage")}</h4>
                        <div className="space-divider margin-top-l"></div>
                        <ul className="list-reset">
                            {changedServices &&
                                changedServices.ServiceList &&
                                changedServices.ServiceList.slice(0, serviceListDetails.noOfServicesToShow).map((srv: any, index: number) => (
                                    <li key={"service-remove-" + index}>
                                        <em className="las la-check-circle inline-icon status-good"></em>
                                        <span className="subscription-changed-item">
                                            <h5>{srv.DisplayName}</h5>
                                        </span>
                                    </li>
                                ))}
                        </ul>
                        {changedServices &&
                            changedServices.ServiceList &&
                            changedServices.ServiceList.length > 5 ?
                            <a href="#" onClick={showLessOrMoreServices}>
                                {serviceListDetails.isServiceListExpanded ? "See less" : "See more"}
                            </a> : ""
                        }
                    </React.Fragment>
                ) : (
                    <div className="box loading"></div>
                )}

                {!isPayAsYouGo && (
                    <p className="padding-top-s">
                        {tLang("dashboard.cacellationContinuationDialog.call")} <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a>
                    </p>
                )}
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            id="btn-cancel-dark-web-add-financial-acc"
                            className="btn-default btn-link btn-no-padding btn-no-border"
                            onClick={() => onLogout()}
                        >
                            <span className="btn-text">{isPayAsYouGo ? "No Thanks" : "No Thanks Please Log Me Out"}</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" id="btn-cancellation-coninuation-submit" onClick={() => onSubmit()}>
                            <span className="btn-text">
                                {isPayAsYouGo ? "Yes, Renew My Plan" : changedServices && changedServices.BtnCancellationContinuationAcceptText}
                            </span>
                        </button>
                    </div>
                </div>
                {isPayAsYouGo && (
                    <div style={{ textAlign: "center", padding: "10px" }}>
                        <p className="padding-top-s">
                            If you have questions about this change, please call <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a>
                        </p>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};
export default CancellationContinuationDialog;
